import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";
import {rxInit} from "./appSlice";

const rulesAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.position - b.position
});

const initialState = {
  rules: rulesAdapter.getInitialState(),

  editor: {
    show: false,
    mode: null,
    deleteConfirmationModal: false
  }
};

export const rulesSlice = createSlice({
  name: "rules",
  initialState,
  reducers: {
    showEditor: (state, action) => {
      state.editor.show = true;
      state.editor.mode = action.payload.mode;
      state.editor.rule = action.payload.rule;
      state.editor.deleteConfirmationModal = false;
    },

    hideEditor: state => {
      state.editor.show = false;
      state.editor.deleteConfirmationModal = false;
    },

    showHideDeleteConfirmationModal: (state, action) => {
      state.editor.deleteConfirmationModal = action.payload;
    },

    updateRules: (state, action) => {
      rulesAdapter.setMany(state.rules, action.payload.u || []);
      rulesAdapter.removeMany(state.rules, action.payload.d || []);
    },

    reorderRules: (state, action) => {
      let position = 0;

      rulesAdapter.setMany(state.rules, action.payload.map(r => ({...r, position: position++})));
    }
  },
  extraReducers: builder => {
    builder.addCase(rxInit, (state, action) => {
      rulesAdapter.setMany(state.rules, action.payload.transactionRules);
    });
  }
});

export const {
  showEditor: rxShowRuleEditor,
  hideEditor: rxHideRuleEditor,
  updateRules: rxUpdateRules,
  showHideDeleteConfirmationModal: rxShowHideDeleteConfirmationModal,
  reorderRules: rxReorderRules
} = rulesSlice.actions;

export const {selectAll: selectAllRules} = rulesAdapter.getSelectors(state => state.rules.rules);

export const editorConfigSelector = state => state.rules.editor;

export default rulesSlice.reducer;
